import React from "react";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

const ExportPDFButton = ({ contentRef }) => {
  const handleExportPDF = async () => {
    if (contentRef && contentRef.current) {
      const contentElement = contentRef.current;

      try {

        const originalHeight = contentElement.scrollHeight;
        const originalOverflow = contentElement.style.overflow;
        
        contentElement.style.overflow = "visible";

        const canvas = await html2canvas(contentElement, {
          scale: 2, 
          height: originalHeight, 
          useCORS: true, 
        });

        contentElement.style.overflow = originalOverflow;

        const imgData = canvas.toDataURL("image/png");

        const pdf = new jsPDF("p", "mm", "a4");
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();

        const imgWidth = canvas.width;
        const imgHeight = canvas.height;

        const pageHeight = (pdfWidth / imgWidth) * imgHeight;
        let currentHeight = 0;

        while (currentHeight < imgHeight) {
          const canvasSection = document.createElement("canvas");
          canvasSection.width = canvas.width;
          canvasSection.height = Math.min(canvas.height - currentHeight, pdfHeight * imgWidth / pdfWidth);

          const sectionContext = canvasSection.getContext("2d");
          sectionContext.drawImage(
            canvas,
            0,
            -currentHeight, 
            canvas.width,
            canvas.height
          );

          const sectionData = canvasSection.toDataURL("image/png");
          if (currentHeight > 0) pdf.addPage();
          pdf.addImage(sectionData, "PNG", 0, 0, pdfWidth, pdfHeight);

          currentHeight += canvasSection.height;
        }

        pdf.save("document.pdf");
      } catch (error) {
        console.error("Error exporting to PDF:", error);
      }
    } else {
      console.error("Content reference is not valid.");
    }
  };

  return (
    <button
      onClick={handleExportPDF}
      className="the-export-pdf-button"
    >
      Export to PDF
    </button>
  );
};

export default ExportPDFButton;
